import React from 'react';
import { Helmet } from 'react-helmet';
import { Route, Switch } from 'react-router';
import { TranscribeLoader } from '../helpers/ai/transcribe/TranscribeLoader';
import { TranscribeViewer } from '../helpers/ai/transcribe/TranscribeViewer';
import { AI_UTILITIES } from '../constants/aiUtilities';
import { useTheme } from '../components/hooks/useTheme';
import './Shared.css';

export const Transcribe = () => {
    const { theme } = useTheme();

    const icon = theme === 'light' ? AI_UTILITIES.TRANSCRIBE.lightIcon : AI_UTILITIES.TRANSCRIBE.darkIcon;

    return (
        <div>
            <Helmet>
                <title>{AI_UTILITIES.TRANSCRIBE.name}</title>
            </Helmet>
            <div className="d-flex flex-row align-items-center mb-3">
                <img src={icon} alt="Логотип" className='title-icon mr-3' />
                <h4>{AI_UTILITIES.TRANSCRIBE.name}</h4>
            </div>
            <Switch>
                <Route exact path={AI_UTILITIES.TRANSCRIBE.path} component={TranscribeLoader} />
                <Route path={`${AI_UTILITIES.TRANSCRIBE.path}/:inputIdentifier`} component={TranscribeViewer} />
            </Switch>
        </div>
    );
};

Transcribe.displayName = 'Transcribe';